<div class="pdb-container" *ngIf="internalPointsAsCurrency">
    <div class="pdb-text">{{ foreText }}</div>
    <div class="pdb-discount-text" [ngClass]="{ free: isFree }">
        {{ discountText }}
        <sup *ngIf="!isFree" class="pdb-discount-perc">%</sup>
    </div>
    <div class="pdb-hidden">{{ afterText }}</div>
</div>
